export default __webpack_public_path__ + "static/media/learose-1024w.97867f72.png";